<template>
  <div>
    <div class="doses-list">
      <h4>{{ title }}:</h4>
      <div v-for="(dose, index) in doses" :key="index">
        <div
          class="doses-list-item"
          :class="dose.cor"
          @click="onClickDose(dose)"
        >
          <strong>{{ dose.dose }}</strong>
          <span>{{ dose.dt_plc_br }}</span>
        </div>
      </div>
    </div>

    <SalvarVacinaModal
      v-model="modalShow"
      :title="`${title} - ${selectedDose?.dose}`"
      :item="cidadao"
      :dose="selectedDose"
      :mode="mode"
      @saved="onDoseSaved"
      @updated="$emit('updated', $event)"
    />
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'
import SalvarVacinaModal from '@/pages/Imunizacao/components/SalvarVacinaModal.vue'

export default {
  name: 'ItemDoses',
  props: {
    title: { type: String, default: '' },
    doses: { type: [Array, Boolean], default: false },
    cidadao: { type: Object, default: () => null },
  },
  components: { SalvarVacinaModal },
  mixins: [utils],
  data() {
    return {
      modalShow: false,
      selectedDose: null,
      mode: 'create',
    }
  },
  methods: {
    /**
     * Manipula o clique em uma dose de vacina.
     * Define o cidadão selecionado e abre o modal para criação ou edição da dose.
     * @param {Object} dose Dados da dose selecionada
     */
    onClickDose(dose) {
      if (!dose) return

      // só insere se for white ou red
      if (dose.cor === 'white' || dose.cor === 'red') {
        this.mode = 'create'
        this.selectedDose = dose
        this.modalShow = true
        return
      }

      // edição depende de orig==3
      this.mode = 'edit'
      this.selectedDose = dose
      this.modalShow = true
    },

    /**
     * Manipula ao finalizar o salvamento de uma dose
     * @param {Object} payload
     */
    onDoseSaved(payload) {
      this.$emit('disabled-btn-processar', false)
      this.$emit('show-alert-processar', false)
      this.modalShow = false
    },
  },
}
</script>

<style scoped lang="scss">
.doses-list {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
  gap: 20px;
  margin: 20px 0;
  background-color: #f1f0f5;
  padding: 15px;
  h4 {
    font-size: 16px;
    margin-bottom: 0;
    width: 15%;
  }
  .doses-list-item {
    background-color: #fff;
    min-width: 120px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 10px;
    border: 1px solid #ccc;
    color: #000;
    border-radius: 6px;
    cursor: pointer;
    &.red {
      background: #ffb3b3 !important;
      cursor: pointer;
      // border-color: #990000 !important;
    }
    &.green {
      background: #b3ffb3;
      // border-color: #008000 !important;
    }
    &.white {
      background: #fff;
      cursor: pointer;
      // border-color: #000 !important;
    }
  }
}
</style>
